import { RichText } from 'components/Text/RichText';
import { CmsApiRichTextBlockData } from 'modules/cms/api/types/CmsApiRichText';

type Props = {
  blockIndex: number;
  data: CmsApiRichTextBlockData;
  fullWidthLayout?: boolean;
  isSidebar?: boolean;
};

export function CmsRichTextBlock({
  blockIndex,
  data: { html },
  fullWidthLayout,
  isSidebar,
}: Props) {
  return (
    <RichText
      dangerouslySetInnerHTML={{
        __html: html,
      }}
      textAlign={fullWidthLayout && 'center'}
      small={isSidebar}
      analyticsData={{
        eventName: 'CMS Block',
        eventProperties: {
          block_position: blockIndex,
          block_type: 'Rich Text',
        },
      }}
    />
  );
}
